import React, { Component } from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import Styles from './RadioGroup.styles';

class RadioGroup extends Component {
  getRadioItem = ({
    checked,
    label,
    name,
    onChange,
    onFocus,
    value,
  }) => {
    const id = `${name}[${value}]`;

    return (
      <div key={id}>
        <input
          checked={checked}
          id={id}
          name={name}
          onChange={onChange}
          onFocus={onFocus}
          type="radio"
          value={value}
        />
        <label
          className={Styles.label}
          htmlFor={id}
        >
          {label}
        </label>
      </div>
    );
  }

  field = ({ input, meta, options }) => {
    const { name, onChange, onFocus } = input;
    const { touched, error } = meta;

    const radios = options.map((option) => this.getRadioItem({
      ...option,
      checked: option.value === input.value,
      name,
      onChange,
      onFocus,
    }));

    return (
      <div className={Styles.default}>
        <div>{radios}</div>
        {touched && error && <p className="error">{error}</p>}
      </div>
    );
  }

  render() {
    const { name, options } = this.props;
    return (
      <Field
        component={this.field}
        name={name}
        options={options}
      />
    );
  }
}

RadioGroup.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
};

export default RadioGroup;
